import L from 'leaflet';

// Example custom icon
export const blueCarIcon = new L.Icon({
  iconUrl: '/map/car-blue.png',
  iconSize: [25, 25],
  iconAnchor: [12, 25],
  popupAnchor: [1, -23],
});

export const greenCarIcon = new L.Icon({
  iconUrl: '/map/car-green.png',
  iconSize: [25, 25],
  iconAnchor: [12, 25],
  popupAnchor: [1, -23],
});

export const departureMakerIcon = new L.Icon({
  iconUrl: '/map/departure-marker-icon.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowUrl: '/map/marker-shadow.png',
  shadowSize: [41, 41],
});

export const destinationMarkerIcon = new L.Icon({
  iconUrl: '/map/destination-marker-icon.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowUrl: '/map/marker-shadow.png',
  shadowSize: [41, 41],
});